export default {"src":"/_next/static/media/Fansly.8b8ebaea.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};